/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import '../../hooks/useConfig.mjs';
import { COMPONENT_NAME } from '../const.mjs';
import { getDayCn } from '../utils.mjs';
import { i as isObject_1 } from '../../_chunks/dep-4efc69ee.mjs';
import { useConfig } from '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-97c71289.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-493c38ce.mjs';
import '../../_chunks/dep-b56b2dc0.mjs';
import '../../_chunks/dep-77f634fb.mjs';
import '../../_chunks/dep-28ae3cda.mjs';
import '../../_chunks/dep-e50fa7b0.mjs';
import '../../_chunks/dep-ae08d6c4.mjs';
import '../../_chunks/dep-7211604f.mjs';
import '../../_chunks/dep-75df64b1.mjs';
import '../../_chunks/dep-48b9a098.mjs';
import '../../_chunks/dep-c7e4942d.mjs';
import '../../_chunks/dep-8049d2e0.mjs';
import '../../_chunks/dep-0d1bd08c.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-25d66c95.mjs';
import '../../_chunks/dep-372265bb.mjs';
import '../../_chunks/dep-d940e2da.mjs';
import '../../_chunks/dep-52c1d6a9.mjs';
import '../../_chunks/dep-18bb982b.mjs';
import '../../_chunks/dep-c57d8117.mjs';
import '../../_chunks/dep-6043e9fc.mjs';
import '../../_chunks/dep-5f6c8826.mjs';
import '../../_chunks/dep-3a045465.mjs';
import '../../_chunks/dep-53dc0ac1.mjs';
import '../../_chunks/dep-b6b4eaa3.mjs';
import '../../_chunks/dep-881cffb7.mjs';
import '../../_chunks/dep-436b338d.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-2d31a683.mjs';
import '../../_chunks/dep-3ddc95d0.mjs';
import '../../config-provider/type.mjs';

function useColHeaders(props, state) {
  var _useConfig = useConfig(COMPONENT_NAME),
    t = _useConfig.t,
    globalConfig = _useConfig.globalConfig;
  var weekDipalyText = computed(function () {
    return props.week || t(globalConfig.value.week).split(",");
  });
  function getWeekDisplay(weekNum) {
    var weekText = weekDipalyText.value;
    return isObject_1(weekText) && weekText[weekNum - 1] ? weekText[weekNum - 1] : getDayCn(weekNum);
  }
  var cellColHeaders = computed(function () {
    var re = [];
    var min = 1;
    var max = 7;
    for (var i = state.realFirstDayOfWeek; i <= max; i++) {
      re.push({
        num: i,
        display: getWeekDisplay(i)
      });
    }
    if (state.realFirstDayOfWeek > min) {
      for (var _i = min; _i < state.realFirstDayOfWeek; _i++) {
        re.push({
          num: _i,
          display: getWeekDisplay(_i)
        });
      }
    }
    return re;
  });
  return {
    cellColHeaders: cellColHeaders
  };
}

export { useColHeaders };
//# sourceMappingURL=useColHeaders.mjs.map
